import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {FileManagerService} from "../../../shared/services/file-manager.service";
import {HttpErrorResponse} from "@angular/common/http";
import {delay, filter, takeUntil, tap} from "rxjs/operators";
import {DOC_ORIENTATION} from "ngx-image-compress/lib/models/DOC_ORIENTATION";
import {concat, Observable, of, ReplaySubject} from "rxjs";
import {NgxImageCompressService} from "ngx-image-compress";
import {FileInput} from "ngx-material-file-input";
import {FileManager} from "../../../shared/interface/file-manager";
import {FileManagerTag} from "../../../shared/interface/file-manager-tag";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {FileResult} from "../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";

export interface FileAddDialogData {
  catalogLocation?: string;
  file?: FileManager;
}

@Component({
  selector: 'app-add-file-dialog',
  templateUrl: './add-file-dialog.component.html',
  styleUrls: ['./add-file-dialog.component.scss']
})
export class AddFileDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  processingRequest = false;
  fileForm: FormGroup;
  fileNameControl: FormControl;
  fileContentControl: FormControl;
  publicControl: FormControl;
  permissionTagPartnerControl: FormControl;
  permissionRegistrationListControl:  FormControl;
  permissionTagPartnerPartnerControl:  FormControl;
  permissionRegistrationPartnerListControl:  FormControl;
  permissionTagPartnerOfwcaControl:  FormControl;
  permissionRegistrationOfwcaListControl:  FormControl;
  permissionPartnerControl:  FormControl;
  permissionOfwcaControl:  FormControl;
  permissionUserControl:  FormControl;
  permissionUserListControl:  FormControl;
  permissionDepartmentsUserListControl:  FormControl;
  tagControl:  FormControl;
  fileControl: FormControl;
  file?: FileManager;
  formErrors: any = {};
  maxSize = 10500000;
  userPermissions: ReplaySubject<UserPermissions>;
  fileResults: FileResult[] = [];
  permissionCompanyPartnerPartnerControl: FormControl;
  permissionCompanyPartnerOfwcaControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<AddFileDialogComponent>,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private fileManagerService: FileManagerService,
    private imageCompress: NgxImageCompressService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: FileAddDialogData,
  ) {
    this.userPermissions = authService.getUserPermissions();
    this.file = data.file ?? null;
    this.fileControl  = fb.control('', [Validators.required]);
    this.fileForm = this.fb.group({
      fileName: this.fileNameControl = this.fb.control('', [Validators.required]),
      catalog: this.fb.control(data.catalogLocation, []),
      fileContent: this.fileContentControl = fb.control( '' , [Validators.required]),
      public: this.publicControl = fb.control( false , []),
      tag: this.tagControl = this.fb.control([]),
      permissionPartner: this.permissionPartnerControl = this.fb.control(false),
      permissionOfwca: this.permissionOfwcaControl = this.fb.control(false),
      permissionUser: this.permissionUserControl = this.fb.control(false),
      permissionUserList: this.permissionUserListControl = this.fb.control([]),
      permissionDepartmentsUserList: this.permissionDepartmentsUserListControl = this.fb.control([]),
      permissionTagPartnerPartner: this.permissionTagPartnerPartnerControl = this.fb.control([]),
      permissionRegistrationPartnerList: this.permissionRegistrationPartnerListControl = this.fb.control([]),
      permissionTagPartnerOfwca: this.permissionTagPartnerOfwcaControl = this.fb.control([]),
      permissionCompanyPartnerPartner: this.permissionCompanyPartnerPartnerControl = this.fb.control([]),
      permissionCompanyPartnerOfwca: this.permissionCompanyPartnerOfwcaControl = this.fb.control([]),
      permissionRegistrationOfwcaList: this.permissionRegistrationOfwcaListControl = this.fb.control([]),
    });
  }

  ngOnInit(): void {
    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {

        this.fileControl.value.forEach((fileToRead: File) => {
          this.fileForm.get('fileName').setValue(fileToRead.name);
          this.fileForm.get('fileContent').reset('');
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.fileForm.get('fileContent').setValue(
              this.fileForm.get('fileContent').value +
              (this.fileForm.get('fileContent').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });
      });
    this.publicControl.valueChanges.subscribe(value => {
      if (value) {
        this.permissionPartnerControl.reset();
        this.permissionOfwcaControl.reset();
        this.permissionUserControl.reset();
        this.permissionUserListControl.reset();
        this.permissionDepartmentsUserListControl.reset();
        this.permissionTagPartnerPartnerControl.reset();
        this.permissionRegistrationPartnerListControl.reset();
        this.permissionTagPartnerOfwcaControl.reset();
        this.permissionCompanyPartnerPartnerControl.reset();
        this.permissionRegistrationOfwcaListControl.reset();
        this.permissionCompanyPartnerOfwcaControl.reset();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.file) {
      this.initialize(this.file);
    } else {
      this.initialized.next(true);
    }
  }

  sendForm(): void {
    if ( !this.fileForm.valid)
    {
      this.fileForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;

    this.formErrors = {};
    if (this.file) {
      this.fileManagerService.sendFile(this.fileForm.value, this.file?.uuid)
        .subscribe(() => {
          this.snack.open(this.file ? 'Pomyślnie zaktualizowano plik' : 'Pomyślnie dodano plik', '', {
            duration: 2000,
          });
          this.processingRequest = false;

          this.dialogRef.close();

        }, (error: HttpErrorResponse) => {
          this.processingRequest = false;
          this.snack.open('Podczas dodawania pliku wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
          if (error.status === 400) {
            this.formErrors = error.error.error.list;
            this.formHelper.setBackendErrorState(this.fileForm, this.formErrors);
          }
        })
      ;
    } else {
      this.fileResults = [];

      this.processingRequest = true;
      const forms: Observable<any>[] = [];
      let lenth = 0;
      this.fileControl.value?.forEach((file: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.fileForm.get('fileName').setValue(file.name);
          this.fileForm.get('fileContent').setValue((/base64,(.+)/.exec(reader.result.toString())[1]));
          forms.push(this.fileManagerService.sendFile(
            this.fileForm.value, this.file?.uuid).pipe(
            tap((as) => {
              this.fileResults.push({
                file,
                result: true,
              });
              lenth++;

              if (lenth === this.fileControl.value?.length) {
                this.snack.open('Pomyślnie dodano pliki', '', {
                  duration: 2000,
                });
                this.processingRequest = false;
                this.dialogRef.close();
              }
            }, (error: HttpErrorResponse) => {
              this.fileResults.push({
                file,
                result: false
              });
            }),
          ));

          if (forms.length === this.fileControl.value?.length) {
            concat(...forms)
              .subscribe(() => {
              }, (error: HttpErrorResponse) => {
                this.processingRequest = false;
                this.snack.open('Przy wczytywaniu pliku wystąpił błąd', error.status.toString(), {duration: 2000});
              });
          }
        };
      });
    }

  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initialize(file: FileManager): void {
    of(file)
      .pipe(
        delay(0),
        tap(() => {
          this.fileContentControl.disable();
          this.fileForm.reset({
            uuid: file.uuid,
            fileName: file.name,
            catalog: file.catalog,
            public: file.public,
            tag:  file.tagId?.split(',') ?? [],
            permissionPartner: file.permissionPartner,
            permissionOfwca: file.permissionOfwca,
            permissionUser: file.permissionUser,
            permissionUserList:  this.parseSerializedDataString(file.permissionUserList),
            permissionDepartmentsUserList:  this.parseSerializedDataString(file.permissionDepartmentsUserList),
            permissionTagPartnerPartner:  this.parseSerializedData(file.permissionTagPartnerPartner),
            permissionRegistrationPartnerList:  this.parseSerializedData(file.permissionRegistrationPartnerList),
            permissionTagPartnerOfwca:  this.parseSerializedData(file.permissionTagPartnerOfwca),
            permissionRegistrationOfwcaList:  this.parseSerializedData(file.permissionRegistrationOfwcaList),
            permissionCompanyPartnerPartner: this.parseSerializedData(file.permissionCompanyPartnerPartner),
            permissionCompanyPartnerOfwca: this.parseSerializedData(file.permissionCompanyPartnerOfwca),
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }


  parseSerializedData(serializedData: string): number[] {

    serializedData = serializedData.replace(/^a:\d+:/, '').slice(0, -1);

    const pairs = serializedData.split(';');

    const resultArray: number[] = [];

    for (const pair of pairs) {
      if (pair) {
        const parts = pair.split(':');
        if (parts[0] === 'd') {
          resultArray.push(parseInt(parts[1], 10));
        }
      }
    }
    return resultArray;
  }

  parseSerializedDataString(serializedData: string): string[] {
    const uuidRegex = /s:\d+:"([a-f0-9-]{36})"/gi;
    const result: string[] = [];

    let match;
    while ((match = uuidRegex.exec(serializedData)) !== null) {
      result.push(match[1]);
    }

    return result;
  }
}
